import {
  GenerateDescriptionProps,
  getGenerateDescriptionDataTooltipText,
} from './GenerateDescriptionButton';
import { SparklesToolbarButton } from './SparklesToolbarButton';

type GenerateDescriptionToolbarButtonProps = {
  isDisabled?: boolean;
  shouldPulse?: boolean;
  generateDescriptionTooltip?: string;
} & GenerateDescriptionProps;

export const GenerateDescriptionToolbarButton = ({
  isDisabled,
  shouldPulse,
  generateDescriptionTooltip = 'Generate description',
  ...props
}: GenerateDescriptionToolbarButtonProps) => {
  const {
    isLoading,
    isMissingItemToDescribe,
    onClick: handleClick,
    hasError,
    missingItemTooltip,
  } = props;

  return (
    <SparklesToolbarButton
      isDisabled={isDisabled}
      isLoading={isLoading}
      isActive={false}
      shouldPulse={shouldPulse}
      onClick={() => {
        if (isMissingItemToDescribe || isLoading) {
          return;
        }
        handleClick();
      }}
      hasError={hasError}
      tooltipText={
        getGenerateDescriptionDataTooltipText(
          isMissingItemToDescribe,
          missingItemTooltip
        ) || generateDescriptionTooltip
      }
    />
  );
};
